import axios from 'axios';

export default async function uploadToS3PresignedUrl(payload: {
  file: File;
  fields: Record<string, string>;
  url: string;
}) {
  const formData = new FormData();
  Object.entries(payload.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  // TODO: 제품의 브라우저 지원 버전이 상향되면, formData.has()로 대체될 수 있습니다.
  if (Object.keys(payload.fields).every((fieldKey) => fieldKey !== 'Content-Type')) {
    formData.append('Content-Type', payload.file.type || 'application/octet-stream');
  }

  formData.append('file', payload.file);

  await axios.post(payload.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
